import {
  eachHourOfInterval,
  addMinutes,
  differenceInHours,
  differenceInMinutes,
  format,
} from 'date-fns'
import i18n from 'translations/i18n'

export function calculateWorkingHours(time) {
  const currentLang = localStorage.Locale

  const initTime = time ? time.split(':') : [1, 0]
  initTime[0] = Math.abs(initTime[0])
  initTime[1] = Math.abs(initTime[1])

  const range = eachHourOfInterval({
    start: new Date(2000, 1, 1, 0, 0),
    end: new Date(2000, 1, 1, initTime[0], initTime[1]),
  })
  const range2 = range.map((date) => addMinutes(date, 30))
  const allOptions = range.concat(range2)
  const sorted = allOptions.sort((item1, item2) => item1 - item2)
  const newArr = sorted.slice(1, -1)

  return time
    ? newArr.map((item, i) => ({
        id: differenceInMinutes(item, new Date(2000, 1, 1, 0, 0)),
        name: `${differenceInHours(item, new Date(2000, 1, 1, 0, 0))}:${
          i % 2 === 0 ? '30' : '00'
        } ${currentLang === 'ar' ? 'ساعات' : 'Hours'}`,
      }))
    : []
}

export function rangeTime() {
  const arr1 = eachHourOfInterval({
    start: new Date(2018, 1, 1, 0, 0),
    end: new Date(2018, 1, 2, 23, 30),
  })
  const arr2 = arr1.map((date) => addMinutes(date, 30))

  const arr3 = arr1.concat(arr2)

  const arr4 = arr3.sort((item1, item2) => item1 - item2)

  return arr4.map((item, i) => {
    if (24 * 2 <= i) {
      return `${format(new Date(item), 'hh:mm aaa')} next day`
    }
    return format(new Date(item), 'hh:mm aaa')
  })
}

export function sliceTime(from) {
  const range = rangeTime()
  const indexFrom = range.indexOf(from) > 0 ? range.indexOf(from) : 0
  return range.slice(indexFrom, indexFrom + 48)
}

export const rangeBufferTimes = () => {
  const minutesInterval = 30 // minutes interval
  const times = [] // time array
  let startTime = 0 // start time

  for (let i = 0; startTime < 12 * 60; i += 1) {
    const hh = Math.floor(startTime / 60)
    const mm = startTime % 60
    times[i] = `${`0${hh % 12}`.slice(-2)}:${`0${mm}`.slice(-2)}`
    startTime += minutesInterval
  }

  const values = times.map((item) => ({
    id: item,
    name: item,
  }))

  const customValues = [
    ...[
      {
        id: ' ',
        name: 'Default',
      },
    ],
    ...values,
    ...[
      {
        id: '12:00',
        name: '12:00',
      },
    ],
  ]

  return customValues
}

export const calculateTimeLeft = (target) => {
  const time = +new Date(target)
  const difference = time - +new Date()
  const minute = 1000 * 60

  const hours =
    Math.floor((difference % (minute * 60 * 24)) / minute) &&
    Math.floor((difference % (minute * 60 * 24)) / (minute * 60))

  const minutes =
    Math.floor((difference % (minute * 60)) / minute) < 10
      ? `0${Math.floor((difference % (minute * 60)) / minute)}`
      : Math.floor((difference % (minute * 60)) / minute)

  const seconds =
    Math.floor((difference / 1000) % 60) < 10
      ? `0${Math.floor((difference / 1000) % 60)}`
      : Math.floor((difference / 1000) % 60)

  if (difference > 0) {
    return {
      hours: parseInt(hours.toString(), 10) > 0 ? hours : null,
      minutes,
      seconds,
    }
  }

  return null
}

export const handleTimer = (time) => {
  if (!time || !time.minutes) return null
  if (time.hours) {
    return i18n.t('reminder_time_hours_minutes', { h: time.hours, m: time.minutes })
  }
  return i18n.t('reminder_time_minutes_seconds', { m: time.minutes, s: time.seconds })
}
